import React from 'react';
import { Dropdown } from 'semantic-ui-react';


export const PageSizeSelect = props => (

  <span className="pagination-sizing">
    Records per page: {' '}
    <Dropdown
      inline
      options={[
        { key: '0', value: 2, text: '2' },
        { key: '1', value: 5, text: '5' },
        { key: '2', value: 10, text: '10' },
        { key: '3', value: 25, text: '25' },
        { key: '4', value: 50, text: '50' },
        { key: '5', value: 100, text: '100' },
        { key: '6', value: 'All', text: 'All' }
      ]}
      defaultValue={props.limit}
      onChange={props.onChangeLimit}
    />
  </span>
);
